import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mapEnumText',
})
export class MapEnumTextPipe implements PipeTransform {
  constructor() {}

  transform(value :string, enumValues :any) :string {
    const status :string = value.toUpperCase();
    const enums = enumValues;

    if (status in enums) {
      return enums[status as keyof typeof enumValues];
    }

    return '';
  }
}
